<cap-content-header>
  <cap-title>
    {{ "gefundeneGeometergeschaefte" | translate }}
  </cap-title>
  @if (geometergeschaeftListLoader) {
    <cap-title-functionbar>
      <cap-functionbar-searchresult-buttons [listLoader]="geometergeschaeftListLoader"></cap-functionbar-searchresult-buttons>
    </cap-title-functionbar>
  }
</cap-content-header>
<cap-list-loader [listLoader]="geometergeschaeftListLoader">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-search">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>
<ng-template #tableHeaders>
  <tr>
    <th>
      <cap-column-header [columnName]="'Nummer'" [sortModel]="tableSortModel.columns.get('geometergeschaeft')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Geschäftsstatus'" [sortModel]="tableSortModel.columns.get('status')"></cap-column-header>
    </th>
    @if (isTableWithColumnMutation()) {
      <th>
        <cap-column-header [columnName]="'AV-Mutation'" [sortModel]="tableSortModel.columns.get('avMutation')"></cap-column-header>
      </th>
    }
    <th>
      <cap-column-header [columnName]="'Geschäftstyp'" [sortModel]="tableSortModel.columns.get('geoGeschaeftsArt')"></cap-column-header>
    </th>
    @if (isTableWithColumnVerarbeitungsart()) {
      <th>
        <cap-column-header [columnName]="'Verarbeitungsart'" [sortModel]="tableSortModel.columns.get('verarbeitungsArt')">
        </cap-column-header>
      </th>
    }
    @if (hasPermissionAnzeigeBeschreibung()) {
      <th>
        <cap-column-header [columnName]="'Beschreibung'" [sortModel]="tableSortModel.columns.get('beschreibung')"></cap-column-header>
      </th>
    }
    <th>
      <cap-column-header [columnName]="'Auftragsdatum'" [sortModel]="tableSortModel.columns.get('auftragsDatum')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Abschlussdatum'" [sortModel]="tableSortModel.columns.get('abschlussDatum')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'BereitfürGrundbuch'" [sortModel]="tableSortModel.columns.get('bereitGBDatum')"></cap-column-header>
    </th>
  </tr>
</ng-template>
<ng-template #tableRows>
  @for (geogeschaeft of geometergeschaeftListLoader?.items; track geogeschaeft) {
    <tr>
      <td>
        <cap-kompakt-geometergeschaeft [item]="geogeschaeft.geometergeschaeft" container="body"></cap-kompakt-geometergeschaeft>
      </td>
      <td>
        <cap-link [params]="[geogeschaeft.id.id]" [target]="navTargets.NAV_GEOMETERGESCHAEFT">
          {{ "Geometergeschaeftszustand." + geogeschaeft.status | translate }}
        </cap-link>
      </td>
      @if (isTableWithColumnMutation()) {
        <td>
          @if (geogeschaeft.avMutation !== null) {
            <cap-kompakt-av-mutation [item]="geogeschaeft.avMutation" container="body" style="cursor: default"></cap-kompakt-av-mutation>
          }
        </td>
      }
      <td>
        <cap-link [params]="[geogeschaeft.id.id]" [target]="navTargets.NAV_GEOMETERGESCHAEFT">
          {{ geogeschaeft.geoGeschaeftsArt | translate }}
        </cap-link>
      </td>
      @if (isTableWithColumnVerarbeitungsart()) {
        <td>
          <cap-link [params]="[geogeschaeft.id.id]" [target]="navTargets.NAV_GEOMETERGESCHAEFT">
            {{ geogeschaeft.verarbeitungsArt | translate }}
          </cap-link>
        </td>
      }
      @if (hasPermissionAnzeigeBeschreibung()) {
        <td>
          <cap-link [params]="[geogeschaeft.id.id]" [target]="navTargets.NAV_GEOMETERGESCHAEFT">
            {{ geogeschaeft.beschreibung }}
          </cap-link>
        </td>
      }
      <td>
        <cap-link [params]="[geogeschaeft.id.id]" [target]="navTargets.NAV_GEOMETERGESCHAEFT">
          {{ geogeschaeft.auftragsDatum | datum }}
        </cap-link>
      </td>
      <td>
        <cap-link [params]="[geogeschaeft.id.id]" [target]="navTargets.NAV_GEOMETERGESCHAEFT">
          {{ geogeschaeft.abschlussDatum | datum }}
        </cap-link>
      </td>
      <td>
        <cap-link [params]="[geogeschaeft.id.id]" [target]="navTargets.NAV_GEOMETERGESCHAEFT">
          {{ geogeschaeft.bereitGBDatum | datum }}
        </cap-link>
      </td>
    </tr>
  }
</ng-template>
